class AdvertFormController {
  constructor() {
    this.name = 'advertForm';
  }
}

export default AdvertFormController;
